import React, { useState } from 'react';

const SubItemList = ({ subItems, onEdit }) => {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredSubItems = subItems.filter(item =>
    item.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="bg-white p-6 shadow rounded">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold">SubItems</h3>
        <input
          type="text"
          placeholder="Search by name"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="px-3 py-2 border border-gray-300 rounded w-64"
        />
      </div>

      <div className="overflow-x-auto">
        <table className="min-w-full text-sm text-left border border-gray-200">
          <thead className="bg-gray-100 text-xs uppercase text-gray-600">
            <tr>
              <th className="px-4 py-2 border">Name</th>
              <th className="px-4 py-2 border">Unit</th>
              <th className="px-4 py-2 border">Description</th>
            </tr>
          </thead>
          <tbody>
            {filteredSubItems.map((item) => (
              <tr
                key={item.id}
                onClick={() => onEdit(item)}
                className="border-t hover:bg-blue-50 cursor-pointer"
              >
                <td className="px-4 py-2">{item.name}</td>
                <td className="px-4 py-2">{item.unit || '—'}</td>
                <td className="px-4 py-2 text-gray-600">{item.description || '—'}</td>
              </tr>
            ))}
            {filteredSubItems.length === 0 && (
              <tr>
                <td colSpan="3" className="px-4 py-4 text-center text-gray-500">
                  No subitems found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SubItemList;
